import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import logoDark from '../../assets/logo-simple-dark.svg';
import logoWhite from '../../assets/logo-simple-white.svg';
import faceOne from '../../assets/faceone.jpg';
import faceTwo from '../../assets/facetwo.jpg';
import faceThree from '../../assets/face3.jpg';
import smartCampusHero from '../../assets/smart-campus-hero-dog-pexels.jpg';

export function AuthPageFrame({ eyebrow, title, description, children, footer, step, showcaseVideo, className = '' }) {
  return (
    <main className={`smart-auth-page ${className}`.trim()}>
      <section className="smart-auth-shell">
        <aside className={`smart-auth-showcase ${showcaseVideo ? 'smart-auth-showcase--video' : ''}`} style={{ '--auth-image': `url(${smartCampusHero})` }}>
          {showcaseVideo ? (
            <video className="smart-auth-showcase-video" autoPlay defaultMuted loop muted playsInline preload="metadata" aria-hidden="true">
              <source src={showcaseVideo} type="video/mp4" />
            </video>
          ) : null}
          <Link className="smart-auth-logo" to="/" aria-label="SmartCampus home">
            <img src={logoWhite} alt="" aria-hidden="true" />
          </Link>
          <div className="smart-auth-showcase-copy">
            <h2>One calm place<br />to run your campus.</h2>
            <p>Bring learners, learning, fees and your whole team together on SmartCampus.</p>
          </div>
          <div className="smart-auth-showcase-bottom">
            <div className="smart-auth-avatars" aria-hidden="true">
              <img src={faceOne} alt="" />
              <img src={faceTwo} alt="" />
              <img src={faceThree} alt="" />
            </div>
            <span>Trusted by 1,000+<br />private tutors</span>
          </div>
        </aside>

        <section className="smart-auth-card" aria-labelledby="auth-title">
          <div className="smart-auth-card-inner">
            <div className="smart-auth-card-top">
              <Link className="smart-auth-mobile-logo" to="/" aria-label="SmartCampus home">
                <img src={logoDark} alt="" aria-hidden="true" />
              </Link>
              {step ? <span className="smart-auth-step">{step}</span> : null}
            </div>
            <div className="smart-auth-heading">
              {eyebrow ? <span>{eyebrow}</span> : null}
              <h1 id="auth-title">{title}</h1>
              <p>{description}</p>
            </div>
            {children}
            {footer ? <div className="smart-auth-footer">{footer}<ArrowUpRight size={16} aria-hidden="true" /></div> : null}
          </div>
        </section>
      </section>
    </main>
  );
}
